import { Box, Grid, Tooltip } from '@material-ui/core';
import React, { memo, useEffect, useState } from 'react';
import { useLang } from '../../util/lang';

export const imageType = {
    smileDesign: 'smileDesign',
    aligner: 'aligner',
};
// tooltip: https://v4.mui.com/components/tooltips/#custom-child-element
const MyButton = React.forwardRef((props, ref) => {
    const { handleOnClick, isBorderRadius, disabled, src, isHover, setIsHover, hoverText } = props;
    const transition = () => {
        if (hoverText) {
            return 'filter 0.3s ease';
        } else {
            return 'transform 0.3s ease';
        }
    };

    return (
        <div style={{ width: '250px', position: 'relative' }} ref={ref} {...props}>
            <img
                alt="newTrioClearCase"
                src={src}
                width={'100%'}
                height={'100%'}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                onClick={handleOnClick}
                style={{
                    objectFit: 'contain',
                    borderRadius: isBorderRadius ? 20 : 0,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    filter:
                        hoverText && isHover
                            ? 'grayscale(100%) drop-shadow(5px 19px 11px #B0B0B0)'
                            : 'drop-shadow(5px 19px 11px #B0B0B0)',
                    opacity: disabled ? 0.5 : 1, // Reduce opacity if button is disabled
                    transition: transition(),
                    transform: !hoverText && isHover ? 'scale(0.97)' : 'scale(1)',
                    maxHeight: 120,
                    pointerEvents: disabled ? 'none' : 'auto', // Disable pointer events if button is disabled
                }}
            />
            {hoverText && !disabled && (
                <div
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    onClick={handleOnClick}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        color: 'white',
                        zIndex: 1, // Ensure the overlay is on top
                        opacity: isHover ? 1 : 0, // Set opacity based on hover state
                        transition: 'opacity 0.3s ease', // Add transition for opacity
                        cursor: disabled ? 'not-allowed' : 'pointer',
                    }}
                >
                    <img
                        alt="newTrioClearCase"
                        src={src}
                        width={'100%'}
                        height={'100%'}
                        style={{
                            objectFit: 'contain',
                            filter: ' blur(2px) brightness(55%)', // Make the image grey
                            borderRadius: isBorderRadius ? 20 : 0,
                            position: 'absolute',
                            marginTop: -2,
                            zIndex: -1, // Ensure the image is behind the text
                        }}
                    />
                    {hoverText}
                </div>
            )}
        </div>
    );
});

const ImageButton = ({
    handleOnClick,
    src = './img/createCase/newTrioClearCase.png',
    isBorderRadius = false,
    isClicked = false,
    disabled = false,
    toolTipPlacement = 'bottom-start',
    imageTypeProps,
    isTooltip,
    hoverText,
}) => {
    const [isHover, setIsHover] = useState(false);
    const get = useLang();
    return (
        <>
            {isTooltip ? (
                <Tooltip
                    title={
                        <div style={{ margin: 10 }}>
                            <div style={{ fontSize: '15px' }}>{get(`@PatientInfo.msg.smileDesignTip`)}</div>
                        </div>
                    }
                    aria-label="add"
                    placement={toolTipPlacement}
                    arrow
                    interactive
                >
                    <MyButton
                        handleOnClick={handleOnClick}
                        isBorderRadius={isBorderRadius}
                        disabled={disabled}
                        src={src}
                        isHover={isHover}
                        setIsHover={setIsHover}
                        hoverText={hoverText}
                    />
                </Tooltip>
            ) : (
                <MyButton
                    handleOnClick={handleOnClick}
                    isBorderRadius={isBorderRadius}
                    disabled={disabled}
                    src={src}
                    isHover={isHover}
                    setIsHover={setIsHover}
                    hoverText={hoverText}
                />
            )}
        </>
    );
};

export default ImageButton;
